import { render, staticRenderFns } from "./compCoin.vue?vue&type=template&id=7523e338&"
import script from "./compCoin.vue?vue&type=script&lang=js&"
export * from "./compCoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7523e338')) {
      api.createRecord('7523e338', component.options)
    } else {
      api.reload('7523e338', component.options)
    }
    module.hot.accept("./compCoin.vue?vue&type=template&id=7523e338&", function () {
      api.rerender('7523e338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameLog/components/compCoin.vue"
export default component.exports